var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShinControlWhiteEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.09 203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.04,101.5l-93.1,57.54v-19.67c19.34-3.41,35.56-18.22,35.56-37.87s-16.22-34.46-35.56-37.87v-19.68l93.1,57.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.94,
    cy: 101.5,
    r: 21.98,
    transform: "translate(-44.82 150.33) rotate(-80.78)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.72,62.78c-3.68,0-6.07,1.4-6.07,3.97,0,8.47,21.96,3.91,21.9,18.75,0,7.65-6.66,12.15-15.65,12.15-6.54,0-12.91-2.63-17.29-6.54l3.27-6.66c4.21,3.85,9.75,6.13,14.13,6.13s7.01-1.75,7.01-4.67c0-8.64-21.96-3.74-21.96-18.46,0-7.18,6.13-11.8,15.3-11.8,5.43,0,10.86,1.75,14.78,4.32l-3.15,6.83c-4.38-2.69-9.11-4.03-12.26-4.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m241.21,77.67v19.51h-7.65v-17.29c0-4.38-2.63-7.07-6.95-7.07-5.14.06-8.23,3.85-8.23,8.99v15.36h-7.59v-38.64l7.59-4.69v18.05c2.22-4.26,6.13-6.19,11.27-6.25,7.18,0,11.56,4.61,11.56,12.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m254.97,57.05c0,2.57-1.87,4.5-4.32,4.5s-4.32-1.93-4.32-4.5,1.87-4.56,4.32-4.56,4.32,1.87,4.32,4.56Zm-.53,8.88v31.25h-7.59v-31.25h7.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m291.33,77.67v19.51h-7.65v-17.29c0-4.38-2.63-7.07-6.95-7.07-5.14.06-8.18,3.85-8.18,8.99v15.36h-7.59v-31.25h7.59v5.84c2.22-4.15,6.13-6.07,11.21-6.13,7.18,0,11.56,4.61,11.56,12.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.8,115.52c-7.71,0-13.72,6.02-13.72,13.78s6.02,13.84,13.72,13.84c3.91,0,8.06-1.87,11.1-4.85l4.61,5.14c-4.21,4.26-10.22,7.07-16.12,7.07-12.03,0-21.32-9.23-21.32-21.08s9.4-20.91,21.61-20.91c5.84,0,11.8,2.51,15.77,6.6l-4.56,5.72c-2.92-3.33-7.07-5.31-11.1-5.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m278.07,130.41v19.51h-7.65v-17.29c0-4.38-2.63-7.07-6.95-7.07-5.14.06-8.18,3.85-8.18,8.99v15.36h-7.59v-31.25h7.59v5.84c2.22-4.15,6.13-6.07,11.21-6.13,7.18,0,11.56,4.61,11.56,12.03Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m302.32,147.99c-2.39,1.46-5.08,2.28-7.83,2.28-5.08,0-9.17-2.92-9.17-9.34v-15.42h-4.38l-.06-5.55h4.44v-4.7l7.53-4.66v9.36h8.94v5.55h-8.94v14.08c0,2.98,1.23,3.97,3.27,3.97,1.28,0,2.74-.47,4.44-1.28l1.75,5.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m324.87,118.38v7.36c-6.6-.41-10.63,3.45-10.63,9.11v15.07h-7.59v-31.25h7.59v6.02c2.1-4.09,5.78-6.25,10.63-6.31Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m371.13,106.58v43.33h-7.59v-38.64l7.59-4.69Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m342.63,118.44c-9.87,0-16.53,6.37-16.53,15.83s6.66,15.94,16.53,15.94,16.41-6.42,16.41-15.94-6.66-15.83-16.41-15.83Zm3.11,24.87c-.95.34-1.99.54-3.11.54s-2.13-.18-3.07-.5c-4.12-1.1-6.74-4.47-6.74-9.05,0-5.6,3.94-9.37,9.78-9.37,0,0,0,0,.01,0,0,0,0,0,.01,0,.06,0,.11,0,.16,0,5.67.08,9.53,3.82,9.53,9.36,0,4.54-2.56,7.89-6.58,9.02Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m228.16,118.44c-9.87,0-16.53,6.37-16.53,15.83s6.66,15.94,16.53,15.94,16.41-6.42,16.41-15.94-6.66-15.83-16.41-15.83Zm3.11,24.87c-.95.34-1.99.54-3.11.54s-2.13-.18-3.07-.5c-4.12-1.1-6.74-4.47-6.74-9.05,0-5.6,3.94-9.37,9.78-9.37,0,0,0,0,.01,0,0,0,0,0,.01,0,.05,0,.11,0,.16,0,5.67.08,9.53,3.82,9.53,9.36,0,4.54-2.56,7.89-6.58,9.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShinControlWhiteEn);
export default __webpack_public_path__ + "static/media/ShinControl_white_en.e21c292228ee877cad64b0253a4bbacc.svg";
export { ForwardRef as ReactComponent };